export interface ProposalExpectationsDto {
   id: string,
   name: string
}

const proposalExpectations = [
   { id: '1', name: 'To treat each other with mutual courtesy and respect' },
   { id: '2', name: 'To complete any pre-work and provide requested information on time' },
   { id: '3', name: 'To communicate any concerns or issues as they arise' },
   { id: '4', name: 'To pay our fees within our payment terms' },
   { id: '5', name: 'To respect our Core Values' },
] as ProposalExpectationsDto[]

export default proposalExpectations